<template>
  <b-modal size="lg"
           ref="modalAddress"
           no-close-on-backdrop
           centered
  >
           <!-- ok-only
           ok-title="Gravar"
           ok-variant="third"
           @ok="" -->
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.ConstructionAddress.Title}}
        </span>
        <button class="close" @click="onHide">x</button>
      </div>
    </template>
    <template #modal-footer>
      <div class="d-flex align-items-right">
        <b-button v-if="!hasCandidate" @click="$emit('update', data)" variant="third" :disabled="stateLatitude === false || stateLongitude === false">{{ $lang.Common.Buttons.Save }}</b-button>
        <b-alert class="m-0" :show="hasCandidate" variant="warning">{{ $lang.PCI.ConstructionAddress.CannotChangeWarning }}</b-alert>
      </div>
    </template>
    <form autocomplete="off" role="presentation" @submit.stop.prevent="" class="d-flex flex-wrap">
      <b-form-group class="col-md-9 mb-3">
        <template #label>{{$lang.PCI.ConstructionAddress.LabelAddress}}</template>
        <b-form-input type="text"
                      name="txtAddress"
                      v-model="data.endereco"
                      :class="addressChangeStyle"/>
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelNumber" class="col-md-3 mb-3">
        <b-form-input type="text"
                      name="txtNumber"
                      v-model="data.numero" />
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelDistrict" class="col-md-5 mb-3">
        <b-form-input type="text"
                      name="txtDistrict"
                      v-model="data.bairro"
                      :class="addressChangeStyle"/>
      </b-form-group>
      <b-form-group class="col-md-2 mb-3">
        <template #label><small>* </small>{{$lang.PCI.ConstructionAddress.LabelState}}</template>
        <b-form-select v-model="data.estado"
                      :options="stateOptions"
                      @change="onChangeState"
                      name="cbxState"
                      :class="addressChangeStyle"
                      :style="!validation.estado ? 'border-color: red;' :''"
                      aria-describedby="validation-uf">
          <template slot="first">
            <option :value="null">
              {{ $lang.Common.PlaceholderSelect }}
            </option>
          </template>
        </b-form-select>
        <small id="validation-uf" v-if="!validation.estado" class="text-danger">Obrigatório</small>
      </b-form-group>
      <b-form-group class="col-md-5 mb-3">
        <template #label><small>* </small>{{$lang.PCI.ConstructionAddress.LabelCity}}</template>
        <b-form-select v-model="data.cidade"
                        :options="cityOptions"
                        @change="() => validation.cidade = !!data.cidade"
                        name="cbxCity"
                        :class="addressChangeStyle"
                        :style="!validation.cidade ? 'border-color: red;' :''"
                        aria-describedby="validation-cidade">
          <template slot="first">
            <option :value="null">
              {{ $lang.Common.PlaceholderSelect }}
            </option>
          </template>
        </b-form-select>
        <small id="validation-cidade" v-if="!validation.cidade" class="text-danger">Obrigatório</small>
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelZIP" class="col-md-3 mb-3">
        <b-form-input type="text"
                      name="txtZIP"
                      v-model="data.cep"
                      v-mask="['#####-###']"
                      @input="checkZipValue"/>
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelAltitude" class="col-md-3 mb-3">
        <b-form-input type="text"
        name="txtAltitude"
        v-model="data.altitude" />
      </b-form-group>
      <div class="col-md-6"></div>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelLatitude" class="col-md-3 mb-3">
        <b-form-input type="number"
                      name="txtLatitude"
                      class="mr-3"
                      @change="validLatitude"
                      @input="generateDms(true)"
                      :state="stateLatitude"
                      v-model="data.latitude" />
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelLatitudeDMS" class="col-md-3 mb-3">
        <b-form-input name="txtLatitudeDms"
                      @change="validLatitude"
                      @input="parseDms(true)"
                      :state="stateLatitude"
                      v-model="data.latitudeDms" />
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelLongitude" class="col-md-3 mb-3">
        <b-form-input type="number"
                      name="txtLongitude"
                      class="mr-3"
                      @change="validLongitude"
                      @input="generateDms(false)"
                      :state="stateLongitude"
                      v-model="data.longitude" />
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelLongitudeDMS" class="col-md-3 mb-3">
        <b-form-input name="txtLongitudeDms"
                      @change="validLongitude"
                      @input="parseDms(false)"
                      :state="stateLongitude"
                      v-model="data.longitudeDms" />
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelType" class="col-md-3 mb-3">
        <b-form-select
                      name="txtType"
                      v-model="data.tipo"
                      :options="typeOptions" />
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelHolder" class="col-md-3 mb-3">
        <b-form-input type="text"
                      name="txtHolder"
                      v-model="data.detentora" />
      </b-form-group>
      <b-form-group :label="$lang.PCI.ConstructionAddress.LabelHolderId" class="col-md-3 mb-3">
        <b-form-input type="text"
                      name="txtHolderId"
                      v-model="data.idDetentora" />
      </b-form-group>
    </form>
  </b-modal>
</template>

<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import { mask } from 'vue-the-mask'
import ZSystemRepository from '@/shared/http/repositories/business/zsystem'
import ObraRepository from '@/shared/http/repositories/business/obra'
import ZipCodeRepository from '@/shared/http/repositories/geo/zipCode'
import worktypes from '../../worktypes'

export default {
  name: 'ConstructionAddress',
  directives: {mask},
  data () {
    return {
      data: {},
      pci: null,
      stateOptions: [],
      cityOptions: [],
      typeOptions: worktypes.types,
      addressChangeStyle: null,
      stateLatitude: null,
      stateLongitude: null
    }
  },
  props: [
    'validation'
  ],
  computed: {
    hasCandidate () {
      return this.pci.possuiCandidato === 'True'
    }
  },
  methods: {
    show (pci) {
      loading.push()
      this.pci = pci
      this.addressChangeStyle = null
      this.validation.cidade = false
      this.validation.estado = false
      ObraRepository.GetAddress(pci.obraId)
        .then(response => {
          this.$nextTick(() => {
            this.data = response.data.data
            this.$refs.modalAddress.show()

            const regex = /(\d+)°(\d+)'([\d.]+)"([NSEW])/i
            if (this.data.latitude) {
              const match = this.data.latitude.trim().match(regex)
              if (match) {
                this.data.latitudeDms = this.data.latitude
                this.data.latitude = this.DMSToDecimal(this.data.latitude)
              } else {
                this.data.latitudeDms = this.decimalToDMS(this.data.latitude, true)
              }
            }
            if (this.data.longitude) {
              const match = this.data.longitude.trim().match(regex)
              if (match) {
                this.data.longitudeDms = this.data.longitude
                this.data.longitude = this.DMSToDecimal(this.data.longitude)
              } else {
                this.data.longitudeDms = this.decimalToDMS(this.data.longitude, true)
              }
            }
          })
        })
        .then(() => this.onLoadAllState())
        .finally(() => loading.close())
    },
    onHide () {
      this.$refs['modalAddress'].hide()
      this.$emit('hide')
    },
    onLoadAllState () {
      loading.push()
      ZSystemRepository.GetAllUF()
        .then((response) => {
          var data = response.data.data
          const result = []
          for (var i in data) {
            result.push({ 'text': data[i].sigla, 'value': data[i].sigla })
          }
          this.stateOptions = [...result]
          this.validation.estado = !!this.data.estado
        })
        .then(() => this.onLoadAllCity(this.data.estado))
        .catch((err) => {
          console.log(err)
        })
        .finally(() => loading.close())
    },
    onChangeState () {
      this.validation.estado = !!this.data.estado
      var self = this
      setTimeout(function (e) {
        self.onLoadAllCity(self.data.estado)
      }, 500)
    },
    onLoadAllCity (state) {
      this.cityOptions = []
      if (state) {
        loading.push()
        const uf = this.stateOptions.filter(s => s.value === state)[0].value
        ZSystemRepository.GetAllCity(uf)
          .then((response) => {
            var data = response.data.data
            const result = []
            for (var i in data) {
              result.push({ 'text': data[i].nome, 'value': data[i].nome })
            }
            this.cityOptions = [...result]

            if (this.data.cidade) {
              let city = this.cityOptions.find(c => c.text.toUpperCase() === this.data.cidade.toUpperCase())
              this.data.cidade = city ? city.text : null
              this.validation.cidade = !!this.data.cidade
            }
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(() => loading.close())
      } else {
        this.data.cidade = null
        this.validation.cidade = false
      }
    },
    async checkZipValue () {
      if (/[\d-]{9}|\d{8}/.test(this.data.cep)) {
        loading.push()
        await ZipCodeRepository.GetByZipCode(this.data.cep.replace(/\D/g, ''))
          .then(async response => {
            if (response.data.erro) return

            this.data.endereco = response.data.logradouro
            this.data.bairro = response.data.bairro

            let reponseUf = response.data.uf ? response.data.uf : ''
            let uf = this.stateOptions.find(s => s.text.toUpperCase() === reponseUf.toUpperCase())

            this.data.estado = uf && this.data.estado !== uf ? uf.text : null
            this.validation.estado = !!this.data.estado

            if (this.data.estado) {
              await ZSystemRepository.GetAllCity(this.data.estado)
                .then((response) => {
                  let data = response.data.data
                  const result = []
                  for (let i in data) {
                    result.push({ 'text': data[i].nome, 'value': data[i].nome })
                  }
                  this.cityOptions = [...result]
                })
                .catch((err) => {
                  console.log(err)
                })
            }

            let responseLocalidade = response.data.localidade ? response.data.localidade : ''
            let city = this.cityOptions.find(c => c.text.toUpperCase() === responseLocalidade.toUpperCase())
            this.data.cidade = city ? city.text : null
            this.validation.cidade = !!this.data.cidade

            this.addressChangeStyle = 'address-change'
          })
          .catch(e => {
            console.log(e)
          })
          .finally(() => loading.close())
      }
    },
    validLatitude () {
      this.data.latitude = this.data.latitude ? this.data.latitude.match(/^-?\d+(\.\d{0,8})?/g)[0] : ''
      const latitude = this.data.latitude
      const valid = !latitude || (parseFloat(latitude) >= -56.5925 && parseFloat(latitude) <= 12.4604)
      this.stateLatitude = null
      if (!valid) {
        this.stateLatitude = false
        toast.error(this.$lang.PCI.WorkMaintenance.InvalidLatitude)
      } else {
        this.stateLatitude = null
        this.data.latitudeDms = this.decimalToDMS(parseFloat(latitude), true)
      }
      return valid
    },
    validLatitudeDms () {
      try {
        this.data.latitudeDms = this.data.latitudeDms ? this.data.latitudeDms.match(/^\d+°\d+'\d+(\.\d+)?"[NSEW]$/g)[0] : this.data.latitude = ''
        this.data.latitude = this.DMSToDecimal(this.data.latitudeDms, true)
      } catch (e) {
        this.data.latitudeDms = ''
        this.stateLatitude = false
        toast.error(this.$lang.PCI.WorkMaintenance.InvalidLatitude)
      }
      return this.validLatitude()
    },
    validLongitude () {
      this.data.longitude = this.data.longitude ? this.data.longitude.match(/^-?\d+(\.\d{0,8})?/g)[0] : ''
      const longitude = this.data.longitude
      const valid = !longitude || (parseFloat(longitude) >= -81.3274 && parseFloat(longitude) <= -34.7939)
      this.stateLongitude = null
      if (!valid) {
        this.stateLongitude = false
        toast.error(this.$lang.PCI.WorkMaintenance.InvalidLongitude)
      } else {
        this.stateLongitude = null
        this.data.longitudeDms = this.decimalToDMS(parseFloat(longitude), false)
      }
      return valid
    },
    generateDms (isLat) {
      if (isLat) {
        this.data.latitudeDms = this.decimalToDMS(parseFloat(this.data.latitude), true)
      } else {
        this.data.longitudeDms = this.decimalToDMS(parseFloat(this.data.longitude), false)
      }
    },
    parseDms (isLat) {
      if (isLat) {
        this.data.latitude = this.DMSToDecimal(this.data.latitudeDms, true)
      } else {
        this.data.longitude = this.DMSToDecimal(this.data.longitudeDms, false)
      }
    },
    decimalToDMS (decimal, isLat = true) {
      if (isNaN(decimal)) return ''

      const dir = decimal >= 0
        ? (isLat ? 'N' : 'E')
        : (isLat ? 'S' : 'W')
      const abs = Math.abs(decimal)
      const degrees = Math.floor(abs)
      const minutesFull = (abs - degrees) * 60
      const minutes = Math.floor(minutesFull)
      const seconds = ((minutesFull - minutes) * 60).toFixed(2)

      return `${degrees}°${minutes}'${seconds}"${dir}`
    },
    DMSToDecimal (dms) {
      // Remove espaços e normaliza símbolos
      dms = dms
        .trim()
        .replace(/[^\d\w.°'"-]+/g, ' ') // Substitui separadores estranhos por espaço
        .replace(/[°º]/g, '°')
        .replace(/[′’]/g, "'")
        .replace(/[″”]/g, '"')

      const regex = /(\d+(?:\.\d+)?)\s*[°º]?\s*(\d+(?:\.\d+)?)?\s*['′]?\s*(\d+(?:\.\d+)?)?\s*["″]?\s*([NSEW])/i
      const match = dms.trim().match(regex)

      if (!match) {
        toast.error(this.$lang.PCI.ConstructionAddress.InvalidDmsFormat)
        return ''
      }

      const deg = parseFloat(match[1])
      const min = parseFloat(match[2]) || 0
      const sec = parseFloat(match[3]) || 0
      const dir = match[4].toUpperCase()

      let decimal = parseInt(deg) + parseInt(min) / 60 + parseFloat(sec) / 3600

      if (dir.toUpperCase() === 'S' || dir.toUpperCase() === 'W') {
        decimal *= -1
      }

      return decimal.toFixed(8)
    }
  }
}
</script>

<style scoped>
* >>> .modal-header {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
* >>> .modal-body {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  overflow: hidden;
}
* >>> .modal-footer {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
* >>> .modal-content {
  border-radius: 25px;
}
* >>> .address-change {
  font-weight: bold;
  background-color: lightyellow;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/construction/constructionAddress.vue